module.exports = __webpack_public_path__ + "media/images/method-cashbill-f6d5e32d165e17d2183ace2b7a4fd8a2.png";